import url from 'url'

const parseURL = url.parse
const PORT = String(process.env.PORT) !== '80' && String(process.env.PORT)

const APP = {
  APP_ENV: String(process.env.APP_ENV) || 'production',
  ASSET_PREFIX: String(process.env.ASSET_PREFIX) || '',
  APP_VERSION: String(process.env.APP_VERSION) || '',
  BANNER: String(process.env.BANNER) || false,
  PORT,
  APP_URL: String(process.env.APP_URL),
  APP_DOMAIN: parseURL(String(process.env.APP_URL)).hostname,
  APP_PREVIEW_URL: String(process.env.APP_PREVIEW_URL),
  SECURE_COOKIE: String(process.env.SECURE_COOKIE) === 'true',
  COOKIE_NAME: process.env.COOKIE_NAME
    ? String(process.env.COOKIE_NAME)
    : 'auth_token',
  COOKIE_DOMAIN: String(process.env.COOKIE_DOMAIN),
  IS_PREVIEW: String(process.env.IS_PREVIEW) === 'true',
  NO_INDEX:
    String(process.env.NO_INDEX) === 'true' ||
    String(process.env.NO_INDEX) === '1' ||
    false,
  USE_PWA:
    String(process.env.USE_PWA) === '1' ||
    String(process.env.NEXT_PUBLIC_USE_PWA) === '1',
  USE_SERVICE_WORKER:
    String(process.env.USE_SERVICE_WORKER) === '1' ||
    String(process.env.NEXT_PUBLIC_USE_SERVICE_WORKER) === '1',
  TWA_PACKAGE_NAME: String(process.env.TWA_PACKAGE_NAME) || '',
  IGNORE_API_SSL_ERRORS:
    String(process.env.IGNORE_API_SSL_ERRORS) === 'true' ||
    String(process.env.IGNORE_API_SSL_ERRORS) === '1' ||
    false,
  MAIN_URL:
    String(process.env.APP_ENV) === 'production'
      ? 'https://www.mangerbouger.fr'
      : 'https://recette.mangerbouger.fr',
  SPECIAL_MENU_LABEL: 'Mes Outils',
  USE_IMAGE_PROXY: String(process.env.USE_IMAGE_PROXY) === '1',
  WONDERPUSH_WEB_KEY: String(process.env.WONDERPUSH_WEB_KEY),
  FEEDBACK_DURATION: 5000,
}

export default APP
